import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { IoClose } from 'react-icons/io5';

export default function ConfirmDialog(props) {
 

  return (
    <React.Fragment>
     
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box sx={{ position: 'absolute', top: '8px', right: '8px', cursor: 'pointer', fontSize: '20px' }} onClick={props.handleClose}>
            <IoClose />
        </Box>
        <DialogTitle id="alert-dialog-title">
          <Typography variant='h3' sx={{ textAlign: 'left', fontWeight: 'bold' }}>Confirmation</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please confirm to proceed with the mapping.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{display: 'flex', justifyContent: 'center'}}>
          <Button sx={{borderRadius:'8px'}} size='small' color='secondary' variant='contained' onClick={props.handleSubmit} autoFocus>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
